import { routes } from "./routes";
import { HeartOutlined, HomeOutlined, PlayCircleOutlined } from "@ant-design/icons";

export const sidebarItems = [
  {
    label: "Dashboard",
    key: routes.dashboard,
    icon: <HomeOutlined />,
  },
  {
    label: "Playlists",
    key: routes.playlists,
    icon: <PlayCircleOutlined />,
  },
  {
    label: "Favorite",
    key: "",
    icon: <HeartOutlined />,
    children: [
      {
        label: " Your Favorites",
        key: routes.favorite,
      },
      {
        label: "Favorites",
        key: routes.mostFav,
      },
    ],
  },
];
